import { useEditEmailModal } from "./useEditEmailModal";
import { useWSSnackbar } from "@wingspanhq/fe-component-library";

type RunArguments = {
  email: string;
  payeeId: string;
  onSuccess?: () => void;
};

export const useEditEmail = () => {
  const { openSnackbar } = useWSSnackbar();
  const editEmailModal = useEditEmailModal();

  return {
    run({ email, payeeId, onSuccess }: RunArguments) {
      editEmailModal.open({
        email,
        payeeId,
        onSuccess() {
          openSnackbar({
            message: "Email successfully updated",
            type: "success"
          });
          onSuccess?.();
        }
      });
    }
  };
};
